import React from 'react';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { useMediaQuery } from '@mui/material';
import { ReactComponent as AlertIcon } from '../../../../assets/images/alert-circle.svg';
import { ReactComponent as CloseIcon } from '../../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import correctiveActionsGrid from './correctiveActionsGrid';
var CorrectiveActionsplannedPopup = function (_ref) {
    var onClose = _ref.onClose;
    var CourierDetailsElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            p: 1.5,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'dealer',
                    label: 'Deailer ID',
                    placeholder: 'select dealer ID',
                    columnSize: 12
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'Booking date',
                    label: 'Booking date',
                    columnSize: 12
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'Docket number',
                    label: 'Docket number',
                    columnSize: 12
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'No. of sample',
                    label: 'No. of sample',
                    placeholder: 'Enter sample no..',
                    columnSize: 12
                }]
        }];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            rowGap: '20px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(AlertIcon, {
                                height: '20px',
                                width: '20px'
                            }),
                            columnSize: 0,
                            sx: {
                                bgcolor: 'warning.100',
                                cursor: 'default',
                                padding: '12px',
                                color: 'warning.500',
                                ':hover': {
                                    bgcolor: 'warning.100'
                                }
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                fontSize: "small",
                                color: "secondary"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            size: 'small',
                            color: 'secondary'
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Msg',
                    label: "Corrective actions planned",
                    value: null,
                    columnSize: 12,
                    children: "Failure before corrective actions",
                    labelTypographyProps: {
                        fontSize: "xl",
                        fontWeight: 'strong',
                        color: 'text.primary'
                    },
                    color: 'secondary.600'
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 1,
                    border: '1px solid',
                    borderColor: 'secondary.200',
                    borderRadius: '12px',
                    p: 1.5,
                    rowGap: 1.5,
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: '',
                            containerProps: {
                                spacing: 0
                            },
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            sx: {
                                border: 'none',
                                p: 0
                            },
                            contentProps: {
                                spacing: 0,
                                gap: '8px'
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Main defective part details',
                                    fontWeight: 'strong',
                                    columnSize: true
                                }, {
                                    type: FormItemTypes.CardComponent,
                                    name: '',
                                    columnSize: 12,
                                    containerProps: {
                                        m: 0
                                    },
                                    sx: {
                                        padding: '12px 16px',
                                        bgcolor: 'secondary.50',
                                        border: 'none'
                                    },
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            columnSize: 12,
                                            label: 'Main defective part',
                                            fontSize: 'sm',
                                            fontWeight: 'medium'
                                        }]
                                }]
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: '',
                            label: 'ECRR date',
                            required: true,
                            md: 6
                        }, {
                            type: FormItemTypes.TextInput,
                            name: '',
                            label: 'EC number',
                            required: true,
                            md: 6
                        }, {
                            type: FormItemTypes.TextInput,
                            name: '',
                            label: 'Cut off VIN number',
                            required: true,
                            md: 6
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: '',
                            label: 'Cut off date',
                            required: true,
                            md: 6
                        }, {
                            type: FormItemTypes.CheckBox,
                            name: 'mycheck',
                            label: 'Engineering change request release',
                            md: 6
                            // color:secondary[900],
                        }, {
                            type: FormItemTypes.CheckBox,
                            name: 'myc',
                            label: 'Process change request release',
                            md: 6
                        }]
                }, !isMobile ? {
                    type: FormItemTypes.Custom,
                    name: '',
                    columnSize: 12,
                    element: correctiveActionsGrid
                } : null, {
                    type: FormItemTypes.TextInput,
                    name: '',
                    label: 'CQA remarks',
                    columnSize: 12,
                    multiline: true,
                    minRows: 4,
                    placeholder: 'Enter a description'
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            gap: 1.5,
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'end',
            spacing: 0,
            sx: {
                paddingTop: '24px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Cancel',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'outlined',
                    onClick: function () {
                        onClose();
                    },
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Confirm',
                    onClick: function () {
                        onClose('confirm');
                    },
                    color: 'primary',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'contained'
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: 2,
            gap: 2,
            spacing: 0
        }
    });
};
export default CorrectiveActionsplannedPopup;
